import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import { getTranslation } from '../translations';
import { getInitialLanguage } from '../utils/languageDetection';
import Footer from '../components/Footer';
import './AuthPage.css';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [language, setLanguage] = useState(getInitialLanguage());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success(language === 'de' ? 'Passwort-zurücksetzen-E-Mail gesendet! Überprüfen Sie Ihren Posteingang.' : 'Password reset email sent! Check your inbox.');
    } catch (error) {
      toast.error(language === 'de' ? 'Fehler beim Senden der E-Mail. Bitte versuchen Sie es erneut.' : 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{ fontSize: '48px', marginBottom: '20px' }}>📧</div>
              <h2>{language === 'de' ? 'Überprüfen Sie Ihre E-Mail' : 'Check Your Email'}</h2>
              <p style={{ color: '#666', marginTop: '15px' }}>
                {language === 'de' 
                  ? `Falls ein Konto mit ${email} existiert, erhalten Sie in Kürze einen Link zum Zurücksetzen des Passworts.`
                  : `If an account exists with ${email}, you'll receive a password reset link shortly.`
                }
              </p>
              <p style={{ color: '#666', marginTop: '10px' }}>
                {language === 'de' ? 'Der Link läuft in 1 Stunde ab.' : 'The link expires in 1 hour.'}
              </p>
              <Button 
                onClick={() => navigate('/')}
                style={{ marginTop: '30px' }}
              >
                {language === 'de' ? 'Zurück zur Anmeldung' : 'Return to Login'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page" style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      position: 'relative'
    }}>
      {/* Language Selector - Upper Right Corner */}
      <div style={{
        position: 'absolute',
        top: '20px',
        right: '20px',
        zIndex: 1000
      }}>
        <Select 
          value={language} 
          onValueChange={(value) => {
            setLanguage(value);
            localStorage.setItem('appLanguage', value);
          }}
        >
          <SelectTrigger style={{width: '180px', backgroundColor: 'white'}}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="en">🇬🇧 English</SelectItem>
            <SelectItem value="de">🇩🇪 Deutsch</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Main content - centered */}
      <div style={{ flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div className="auth-container">
          <div className="auth-card">
          <h2>{language === 'de' ? 'Passwort vergessen?' : 'Forgot Password?'}</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            {language === 'de' 
              ? 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.'
              : 'Enter your email address and we\'ll send you a link to reset your password.'}
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <Label htmlFor="email">{language === 'de' ? 'E-Mail' : 'Email'}</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={language === 'de' ? 'ihre@email.de' : 'your@email.com'}
                required
              />
            </div>

            <Button type="submit" disabled={loading} className="w-full">
              {loading 
                ? (language === 'de' ? 'Wird gesendet...' : 'Sending...') 
                : (language === 'de' ? 'Link zum Zurücksetzen senden' : 'Send Reset Link')}
            </Button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <Button 
              variant="ghost" 
              onClick={() => navigate('/')}
            >
              {language === 'de' ? '← Zurück zur Anmeldung' : '← Back to Login'}
            </Button>
          </div>
        </div>
        </div>
      </div>
      
      {/* Footer - Sticky at bottom */}
      <Footer language={language} />
    </div>
  );
}
